import { createFileRoute } from "@tanstack/react-router";

import OfferPage from "@/components/OfferPage";
import OfferRetomarPageSafe from "@/components/OfferRetomarPageSafe";

const INANNA_HOSTS = new Set([
  "codigodeinanna.dimmedia.net",
  "retomarpaz.dimmedia.net",
]);

function isInannaHost() {
  return (
    typeof window !== "undefined" &&
    INANNA_HOSTS.has(window.location.hostname)
  );
}

function HostAwareOfferPage() {
  const inanna = isInannaHost();

  if (inanna && typeof document !== "undefined") {
    // A antiga variação clara foi aposentada. A paleta C é a identidade oficial
    // da página de vendas do Código de Inanna, independentemente da query string.
    document.documentElement.dataset["inannaPalette"] = "c";
  }

  return inanna ? <OfferRetomarPageSafe /> : <OfferPage />;
}

export const Route = createFileRoute("/oferta")({
  component: HostAwareOfferPage,
  head: () =>
    isInannaHost()
      ? {
          meta: [
            { title: "O Código de Inanna — A Jornada das Sete Portas do Amor" },
            {
              name: "description",
              content:
                "Em 7 dias, recupere sua paz, sua voz e seu poder no amor pela Jornada das Sete Portas.",
            },
            {
              property: "og:title",
              content: "O Código de Inanna — A Jornada das Sete Portas do Amor",
            },
            {
              property: "og:description",
              content:
                "Uma jornada digital guiada com uma porta, um Código Quântico e uma prática por dia.",
            },
            { property: "og:type", content: "website" },
            { property: "og:url", content: "https://codigodeinanna.dimmedia.net/oferta" },
            {
              property: "og:image",
              content:
                "https://codigodeinanna.dimmedia.net/inanna-topo-jornada-v1.webp",
            },
            { property: "og:image:width", content: "1040" },
            { property: "og:image:height", content: "585" },
            {
              property: "og:image:alt",
              content: "O Código de Inanna — A Jornada das Sete Portas do Amor",
            },
            { name: "twitter:card", content: "summary_large_image" },
            {
              name: "twitter:title",
              content: "O Código de Inanna — A Jornada das Sete Portas do Amor",
            },
            {
              name: "twitter:description",
              content:
                "Em 7 dias, recupere sua paz, sua voz e seu poder no amor.",
            },
            {
              name: "twitter:image",
              content:
                "https://codigodeinanna.dimmedia.net/inanna-topo-jornada-v1.webp",
            },
          ],
          links: [
            {
              rel: "canonical",
              href: "https://codigodeinanna.dimmedia.net/oferta",
            },
          ],
        }
      : {
          meta: [
            { title: "100 Códigos Transformadores do Amor" },
            {
              name: "description",
              content:
                "Recupere sua paz, sua autoestima e a segurança para viver o amor sem se abandonar.",
            },
            { property: "og:title", content: "100 Códigos Transformadores do Amor" },
            {
              property: "og:description",
              content:
                "Um direcionamento diário para fortalecer seus limites, sua segurança emocional e viver relações mais leves e recíprocas.",
            },
            { property: "og:type", content: "website" },
            { name: "twitter:card", content: "summary_large_image" },
          ],
          links: [{ rel: "canonical", href: "/oferta" }],
        },
});
